// extracted by mini-css-extract-plugin
module.exports = {"item":"defaultPadding_item__12gBG"};